import React, { ReactNode, createContext, useContext } from 'react';
import { useGetLineInfoQuery, useGetPlantByIdQuery } from 'api';
import { DataLoader } from 'common/components/DataLoader/DataLoader';
import { useFleetRouter } from '../../hooks/useFleetRouter';

export interface UseLineInfoProps {
  isLoading?: boolean;
  hasMessage?: ReactNode;
  hasError?: ReactNode;
  timeZone?: string;
  [key: string]: unknown;
}

const LineInfoContext = createContext<UseLineInfoProps>({
  isLoading: true
});

export const useLineInfo = (): UseLineInfoProps => useContext(LineInfoContext);

interface Props extends UseLineInfoProps {
  children?: ReactNode | ReactNode[];
}

const getLineInfo = () => {
  const [{ id }] = useFleetRouter();
  const { data:lineData, isLoading: isLineDataLoading, error: lineDataError } = useGetLineInfoQuery({ lineId: id });

  if (lineDataError) return { lineDataError };

  return { lineData, isLineDataLoading, lineId: id };
};

const getPlantInto = (plantId: string) => {
    const { data: plantData, isFetching: isFetchingPlantData, error: plantDataError } = useGetPlantByIdQuery(plantId);
    return { plantData, isFetchingPlantData, plantDataError };
}

export const LineInfoProvider = ({ children }: Props): JSX.Element => {

  const { lineData, lineDataError, isLineDataLoading, lineId } = getLineInfo();
  const { plantData, isFetchingPlantData, plantDataError } = getPlantInto(lineData?.plantId as string);
  const hasError: ReactNode = lineDataError ? true : false;

  return (
    <LineInfoContext.Provider value={{ lineData, isLineDataLoading, lineId, plantData, isFetchingPlantData, plantDataError }}>
      <DataLoader {...{ isLineDataLoading, hasError }} Component={children} />
    </LineInfoContext.Provider>
  );
};
